/**
 * Main App component - Entry point for the HeroCon.Ai application
 * Now uses an onboarding flow instead of traditional navigation
 */

import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { OnboardingFlow } from "@/components/onboarding/OnboardingFlow";
import { BIMViewerStep } from "@/components/onboarding/BIMViewerStep";
import { CelebrationPage } from "@/components/celebration/CelebrationPage";
import { useAuthStore } from "@/store/authStore";
import { useState, useEffect } from "react";

function App() {
  const { isAuthenticated } = useAuthStore();
  const [onboardingCompleted, setOnboardingCompleted] = useState(false);
  const [showCelebration, setShowCelebration] = useState(false);

  // Skip onboarding and go directly to BIM Viewer when user is authenticated
  useEffect(() => {
    if (isAuthenticated) {
      setOnboardingCompleted(true);
    }
  }, [isAuthenticated]);

  const handleOnboardingComplete = () => {
    setOnboardingCompleted(true);
  };

  const handleBackFromCelebration = () => {
    setShowCelebration(false);
  };

  // Show celebration page if requested
  if (showCelebration) {
    return (
      <ProtectedRoute>
        <CelebrationPage onPreviousPage={handleBackFromCelebration} />
      </ProtectedRoute>
    );
  }

  return (
    <ProtectedRoute>
      {onboardingCompleted ? (
        // Use BIMViewerStep design directly when authenticated (skip onboarding)
        <BIMViewerStep
          onComplete={handleOnboardingComplete}
          onPrevious={() => {}} // No previous step when skipping onboarding
          canProceed={true}
          isStandalone={true} // Hide onboarding-specific UI elements
        />
      ) : (
        <OnboardingFlow onComplete={handleOnboardingComplete} />
      )}
    </ProtectedRoute>
  );
}

export default App;
